<template>
    <div class="w-full max-w-4xl flex flex-col items-start justify-start">
        <div class="text-black text-lg font-semibold mt-10">
            Meine Zielvereinbarung
        </div>
        <review
            v-for="targetAgreement in GET_TARGET_AGREEMENTS"
            :key="targetAgreement.id"
            :reviewId="targetAgreement.id"
            :type="'targetAgreement'"
        />
        <div class="mt-4 text-red" v-if="state.errorMessage != null">
            {{ state.errorMessage }}
        </div>
        <custom-button
            @click="VALIDATE_REVIEW"
            class="w-72 h-11 mt-10"
            :text="
                GET_COURSE.target_agreement_finished
                    ? 'Zielvereinbarung eingereicht'
                    : 'Zielvereinbarung einreichen'
            "
            :bgColor="'bg-primary'"
            :textColor="'text-white'"
            :id="'target-agreement-button'"
            ><template #icon>
                <checked-icon
                    class="mr-2"
                    :fillClass="'fill-white'"
                    v-if="GET_COURSE.target_agreement_finished"
            /></template>
        </custom-button>
    </div>
</template>

<script>
import { computed, defineComponent, reactive } from "@vue/runtime-core";
import { useStore } from "vuex";
import { getData } from "../../../common/dataHelper";
import CheckedIcon from "../../../components/icons/CheckedIcon.vue";
import CustomButton from "../../../components/input/CustomButton.vue";
import {
    COURSE_TYPES,
    HELPER_TYPES,
    SLIDE_TYPES,
    STORE_TYPES,
} from "../../../store/types";
import Review from "./reviews/Review.vue";

export default defineComponent({
    components: { CustomButton, Review, CheckedIcon },
    setup() {
        const store = useStore();
        /**
         *  State
         */
        const state = reactive({
            errorMessage: null,
        });
        /**
         *  Functions
         */

        async function VALIDATE_REVIEW() {
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_LOADING_ID}`,
                "target-agreement-button"
            );
            const response = await store.dispatch(
                `${STORE_TYPES.COURSES}/${COURSE_TYPES.VALIDATE_REVIEW}`,
                { type: "targetAgreement" }
            );
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.REMOVE_LOADING_ID}`,
                "target-agreement-button"
            );
            if (getData(response, "status") == 200) {
                store.commit(
                    `${STORE_TYPES.SLIDES}/${SLIDE_TYPES.SET_SLIDE}`,
                    null
                );
                store.commit(
                    `${STORE_TYPES.COURSES}/${COURSE_TYPES.SET_SELECTED_COURSE_TYPE}`,
                    "slide"
                );
                store.commit(
                    `${STORE_TYPES.SLIDES}/${SLIDE_TYPES.SET_SLIDE}`,
                    GET_COURSE.value.sections[0].slides[0]
                );
                GET_COURSE.value.target_agreement_finished = true;
            } else {
                state.errorMessage = getData(response, "response.data.message");
            }
        }
        /**
         *  Computed
         */
        const GET_COURSE = computed(
            () =>
                store.getters[
                    `${STORE_TYPES.COURSES}/${COURSE_TYPES.GET_COURSE}`
                ]
        );
        const GET_TARGET_AGREEMENTS = computed(() => {
            if (getData(GET_COURSE, "value.reviews.targetAgreement") == null) {
                return [];
            }
            return GET_COURSE.value.reviews.targetAgreement;
        });

        /**
         *  Created
         */

        return {
            state,
            VALIDATE_REVIEW,
            GET_COURSE,
            GET_TARGET_AGREEMENTS,
        };
    },
});
</script>
